import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/order/reverse.js
// module id = 434
// module chunks = 0